import {Maps} from './Maps'


(function () {
    if(document.querySelector('#hotspots')){
        new Maps.HotSpots(document.querySelector('#hotspots'))
    }

    if(document.querySelector('#hotels-map')) {
        const Hotels = new Maps.HotelFinderB(document.querySelector('#hotels-map'))
    }

})()